module.exports = __webpack_public_path__ + "static/media/community-file.d26cd968.svg";